<template>
  <div class="position-relative">
    <span
      v-if="unpublished"
      class="position-absolute m-1 badge badge-secondary thumb-badge"
    >U</span>
    <img
      :src="src"
      loading="lazy"
      ref="image"
      alt=" "
      class="thumb-image"
      :class="{faded: unpublished}"
    >
    <b-popover
      :target="() => $refs.image"
      triggers="hover"
      custom-class="media-detail-popover"
      boundary="viewport"
    >
      <div v-if="unpublished" class="position-absolute h5 m-2">
        <span class="badge badge-dark">Unpublished</span>
      </div>
      <img :src="src" loading="lazy" alt=" " class="popover-image">
    </b-popover>
  </div>
</template>

<script>
export default {
  name: 'MediaDetailThumb',
  props: {
    src: String,
    unpublished: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.thumb-image {
  max-width: 100%;
  max-height: 64px;
}
.thumb-badge {
  z-index: 1;
  pointer-events: none;
}
.faded {
  opacity: 0.3;
}

.popover-image {
  max-width: 100%;
  max-height: 90vh;
}
</style>

<style lang="scss">
.media-detail-popover {
  max-width: 65% !important;
}
</style>
